<template>
  <transition name="fade-modal">
    <div class="modal-container align-items-center" v-if="value">
      <div class="panel" :class="classes" :style="style">
        <div class="header">
          <Title v-if="title" :title="title" :titleAlign="titleAlign" />
          <div v-if="titleV2" class="bg-default" style="border-radius: 3px">
            <h1 class="title text-center text-white p-2">{{ titleV2 }}</h1>
          </div>
          <Button
            type="clean"
            class="btn-close"
            @click="handleClose"
            v-if="close"
          >
            <icon-close :size="18" />
          </Button>
        </div>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
import IconClose from 'vue-material-design-icons/Close';
import { Button } from '../Form';
import Title from '../Title';

export default {
  name: 'Modal',
  components: {
    IconClose,
    Button,
    Title,
  },
  props: {
    size: {
      type: String,
      validator: () => ['default', 'large', 'small', 'tiny'],
      default: () => 'default',
    },
    title: {
      type: String,
    },
    titleV2: {
      type: String,
    },
    titleAlign: {
      type: String,
    },
    value: {
      type: Boolean,
    },
    escToClose: {
      type: Boolean,
      default: () => true,
    },
    close: {
      type: Boolean,
      default: () => true,
    },
    onClose: {
      type: Function,
      required: false,
    },
  },
  created() {
    const onEscape = (e) => {
      if (
        this.value &&
        e.keyCode === 27 &&
        e.target._prevClass !== 'vs__search' &&
        this.escToClose
      ) {
        this.handleClose();
      }
    };

    document.addEventListener('keydown', onEscape);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape);
    });
  },
  methods: {
    handleClose() {
      if (this.onClose) {
        this.onClose();
        return;
      }
      this.$emit('input', false);
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        document.querySelector('body').style.overflowY = newValue
          ? 'hidden'
          : 'auto';
      }
    },
  },
  computed: {
    classes() {
      const classes = [`modal-size-${this.size}`];

      if (this.titleV2) {
        classes.push(['pt-0 pl-0 pr-0']);
      }

      return classes.join(' ');
    },
    style() {
      if (this.size === 'large') {
        const styles = ['max-width: 1400px !important;'];
        return styles.join(' ');
      }

      if (this.size === 'tiny') {
        const styles = ['max-width: 478px !important;'];
        return styles.join(' ');
      }

      return false;
    },
  },
};
</script>
